<template>
  <div class="bill" @click=" popShow = false">
    <div class="contentRight2">
      <!-- 账单明细界面 -->
      <div>
        <div class="rightHead">
          <div style="margin:0 0 0 25px;font-size:15px;padding-top:16px;color:#707070;">交接班</div>
        </div>
        <div class="title">
          <div style="color:#000">当前交易数据</div>
          <div>{{shitChangeList.startTime}} 至 {{shitChangeList.nowTime}}</div>
        </div>
        <div class="content">
          <div class="row">
            <div class="content-top row flex-between alignCenter">
              <div class="row">
                <div class="content-top-img">
                  <img src="../../assets/icon/sbsj.png" alt />
                </div>
                <div>
                  <div class="content-top_key">上班时间</div>
                  <div class="content-top_value">{{startTime.time}}</div>
                </div>
              </div>
              <div class="content-top__date">{{startTime.date }}</div>
            </div>
            <div class="content-top row flex-between alignCenter">
              <div class="row">
                <div class="content-top-img">
                  <img src="../../assets/icon/dqsj.png" alt />
                </div>
                <div>
                  <div class="content-top_key">当前时间</div>
                  <div class="content-top_value">{{nowTime.time}}</div>
                </div>
              </div>
              <div class="content-top__date">{{nowTime.date }}</div>
            </div>
            <div class="content-top row flex-between alignCenter">
              <div class="row">
                <div class="content-top-img">
                  <img src="../../assets/icon/gzsc.png" alt />
                </div>
                <div>
                  <div class="content-top_key">工作时长</div>
                  <div class="content-top_value">{{shitChangeList.workHours}}小时</div>
                </div>
              </div>
              <div class="content-top__date">{{nowTime.date }}</div>
            </div>
            <div class="content-top row flex-between alignCenter">
              <div class="column">
                <div class="content-top_key">收银员</div>
                <div class="content-top_value">{{shitChangeList.cashierUserFullName}}</div>
              </div>
              <div>
                <el-popover placement="top-start" width="200" trigger="click" v-model="visible">
                  <div class="center column popWrap">
                    <div class="popIcon">
                      <img src="../../assets/icon/jjb.png" alt />
                    </div>
                    <div class="popText">
                      请仔细核对
                      <span style="color:#FB2F2F">交班金额</span>
                    </div>
                    <div class>确认无误后，务必按时交班</div>
                  </div>
                  <div class="popButton center">
                    <el-button type size="small" slot="reference" @click="visible = false">取消</el-button>
                    <el-button type="primary" size="small" slot="reference" @click="shiftChange">交班</el-button>
                  </div>
                  <el-button type="primary" size="small" slot="reference">交班结算</el-button>
                </el-popover>
                <!-- <el-button type="primary" size="small" slot="reference" @click="print">print</el-button> -->
              </div>
            </div>
          </div>
        </div>
        <div class="information row">
          <div class="ifm-item">
            <div class="montyKey">
              收款金额(元) |
              <span
                style="color:#409EFF;cursor:pointer"
                @click.stop="priceDetail(-55,'收款金额')"
              >明细</span>
            </div>
            <div class="money">
              {{shitChangeList.totalMoney}}
              <span
                class="moneyNumber"
              >/{{shitChangeList.totalMoneyNum}}笔</span>
            </div>
          </div>
          <div class="ifm-item">
            <div class="montyKey">
              退款金额(元) |
              <span
                style="color:#409EFF;cursor:pointer"
                @click.stop="priceDetail(285,'退款金额')"
              >明细</span>
            </div>
            <div class="money">
              {{shitChangeList.refundMoney}}
              <span
                class="moneyNumber"
              >/{{shitChangeList.refundMoneyNum}}笔</span>
            </div>
          </div>
          <div class="ifm-item">
            <div class="montyKey">实收现金(元)</div>
            <div class="money">{{shitChangeList.retailCashMoney}}</div>
          </div>
          <div class="ifm-item">
            <div class="montyKey">
              实收金额(元) |
              <span
                style="color:#409EFF;cursor:pointer"
                @click.stop="priceDetail(885,'实收金额')"
              >明细</span>
            </div>
            <div class="money">{{shitChangeList.retailMoney}}</div>
          </div>
          <div class="ifm-item">
            <div class="montyKey">
              储值金额(元) |
              <span
                style="color:#409EFF;cursor:pointer"
                @click.stop="priceDetail(1190,'储值金额')"
              >明细</span>
            </div>
            <div class="money">
              {{shitChangeList.memberRechargeMoney}}
              <span
                class="moneyNumber"
              >/{{shitChangeList.memberRechargeNum}}笔</span>
            </div>
            <div class="pop row" v-if="popShow" :style="{ left: left + 'px' }">
              <div class="pop-item" v-for="(item,index) in popList" :key="index">
                <div class="alignCenter" style="margin-bottom:10px">
                  <img class="pop-icon" :src="item.img" alt />
                  <span>{{item.name}}</span>
                </div>
                <div>{{item.money.toFixed(2)}}元</div>
                <div>{{item.totalMoneyNum}}笔</div>
              </div>
            </div>
          </div>
        </div>
        <div class="information">
          <!-- 表格 -->
          <div style="margin-top:20px;">
            <el-table :data="tableData" style="width: 100%" align="center">
              <el-table-column label="商品名称" width="180">
                <template slot-scope="scope">{{scope.row.goodsName}}</template>
              </el-table-column>
              <el-table-column align="center" prop="qrcBuyCount" label="销量" width="180"></el-table-column>
              <el-table-column align="center" label="库存">
                <template slot-scope="scope">
                  <span v-if="scope.row.isInfiniteStock == 1">无限库存</span>
                  <span v-if="scope.row.isInfiniteStock == 0">{{scope.row.qrcTotalStockCount}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="block" style="float:right;margin-top:10px;">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="1"
              :page-size="5"
              layout="total, prev, pager, next, jumper"
              :total="totalCount"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 
<script>
import {
  workingInfo,
  goOffWork,
  goToWork,
  workingStatus,
  payTypeAmount
} from "../api";
export default {
  data() {
    return {
      popList: [
        {
          name: "现金",
          img: require("../../assets/icon/xj.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "微信",
          img: require("../../assets/icon/wxzf.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "支付宝",
          img: require("../../assets/icon/zfb.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "POS刷卡",
          img: require("../../assets/icon/sk.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "会员",
          img: require("../../assets/icon/czk.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "标记收款",
          img: require("../../assets/icon/bjskzf.png"),
          money: 0,
          totalMoneyNum: 0
        }
      ],
      visible: false,
      shitChangeList: [],
      userList: "",
      shopInformation: "",
      startTime: { date: "", time: "" },
      nowTime: { date: "", time: "" },
      tableData: [],
      totalCount: 0,
      pageNumber: 0,
      popShow: false,
      left: null,
      payTypeAmountList: [],
      printList: [] //打印数据数组
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    this.workingInfo();
  },
  methods: {
    //打印
    print() {
      console.log(123)
      var arr = this.payTypeAmountList;
      if (!arr) {
        this.$message.error("请等待页面加载");
        return;
      }
      var printlist = {
        memberOrderDetails: {
          list: [
            { name: "现金", money: 0, num: 0 },
            { name: "微信", money: 0, num: 0 },
            { name: "支付宝", money: 0, num: 0 },
            { name: "会员卡", money: 0, num: 0 },
            { name: "标记", money: 0, num: 0 },
            { name: "刷卡", money: 0, num: 0 }
          ],
          totalPrice: 0,
          totalNum: 0
        },
        totalMoneyDetails: {
          list: [
            { name: "现金", money: 0, num: 0 },
            { name: "微信", money: 0, num: 0 },
            { name: "支付宝", money: 0, num: 0 },
            { name: "会员卡", money: 0, num: 0 },
            { name: "标记", money: 0, num: 0 },
            { name: "刷卡", money: 0, num: 0 }
          ],
          totalPrice: 0,
          totalNum: 0
        },
        refundMoneyDetails: {
          list: [
            { name: "现金", money: 0, num: 0 },
            { name: "微信", money: 0, num: 0 },
            { name: "支付宝", money: 0, num: 0 },
            { name: "会员卡", money: 0, num: 0 },
            { name: "标记", money: 0, num: 0 },
            { name: "刷卡", money: 0, num: 0 }
          ],
          totalPrice: 0,
          totalNum: 0
        },
        retailMoneyDetails: {
          list: [
            { name: "现金", money: 0, num: 0 },
            { name: "微信", money: 0, num: 0 },
            { name: "支付宝", money: 0, num: 0 },
            { name: "会员卡", money: 0, num: 0 },
            { name: "标记", money: 0, num: 0 },
            { name: "刷卡", money: 0, num: 0 }
          ],
          totalPrice: 0,
          totalNum: 0
        }
      };

      //储值详情
      arr.memberOrderDetails.forEach(e => {
        printlist.memberOrderDetails.totalPrice += e.money;
        printlist.memberOrderDetails.totalNum += e.orderNum;

        if (e.payInterfacePartyType == 11) {
          printlist.memberOrderDetails.list[0].money = e.money;
          printlist.memberOrderDetails.list[0].num = e.orderNum;
        } else if (e.payInterfacePartyType == 3) {
          printlist.memberOrderDetails.list[1].money = e.money;
          printlist.memberOrderDetails.list[1].num = e.orderNum;
        } else if (e.payInterfacePartyType == 2) {
          printlist.memberOrderDetails.list[2].money = e.money;
          printlist.memberOrderDetails.list[2].num = e.orderNum;
        } else if (e.payInterfacePartyType == 10) {
          printlist.memberOrderDetails.list[3].money = e.money;
          printlist.memberOrderDetails.list[3].num = e.orderNum;
        } else if (
          e.payInterfacePartyType == 9 ||
          e.payInterfacePartyType == 8 ||
          e.payInterfacePartyType == 12 ||
          e.payInterfacePartyType == 13
        ) {
          printlist.memberOrderDetails.list[4].money += e.money;
          printlist.memberOrderDetails.list[4].num += e.orderNum;
          if (e.payInterfacePartyType == 8) {
            printlist.memberOrderDetails.list[5].money = e.money;
            printlist.memberOrderDetails.list[5].num = e.orderNum;
          }
        }
      });
      //收款金额 退款金额 实收金额
      arr.totalMoneyDetails.forEach(e => {
        printlist.totalMoneyDetails.totalPrice += e.money;
        printlist.totalMoneyDetails.totalNum += e.orderNum;
        printlist.refundMoneyDetails.totalPrice += e.refundMoney;
        printlist.refundMoneyDetails.totalNum += e.refundNum;
        printlist.retailMoneyDetails.totalPrice += (e.money - e.refundMoney).toFixed(2);
        printlist.retailMoneyDetails.totalNum += (e.orderNum - e.refundNum).toFixed(2);
        if (e.payInterfacePartyType == 11) {
          printlist.totalMoneyDetails.list[0].money = e.money;
          printlist.totalMoneyDetails.list[0].num = e.orderNum;
          printlist.refundMoneyDetails.list[0].money = e.refundMoney;
          printlist.refundMoneyDetails.list[0].num = e.refundNum;
          printlist.retailMoneyDetails.list[0].money = (e.money - e.refundMoney).toFixed(2);
          printlist.retailMoneyDetails.list[0].num = (e.orderNum - e.refundNum).toFixed(2);
        } else if (e.payInterfacePartyType == 3) {
          printlist.totalMoneyDetails.list[1].money = e.money;
          printlist.totalMoneyDetails.list[1].num = e.orderNum;
          printlist.refundMoneyDetails.list[1].money = e.refundMoney;
          printlist.refundMoneyDetails.list[1].num = e.refundNum;
          printlist.retailMoneyDetails.list[1].money = (e.money - e.refundMoney).toFixed(2);
          printlist.retailMoneyDetails.list[1].num = (e.orderNum - e.refundNum).toFixed(2);
        } else if (e.payInterfacePartyType == 2) {
          printlist.totalMoneyDetails.list[2].money = e.money;
          printlist.totalMoneyDetails.list[2].num = e.orderNum;
          printlist.refundMoneyDetails.list[2].money = e.refundMoney;
          printlist.refundMoneyDetails.list[2].num = e.refundNum;
          printlist.retailMoneyDetails.list[2].money = (e.money - e.refundMoney).toFixed(2);
          printlist.retailMoneyDetails.list[2].num = (e.orderNum - e.refundNum).toFixed(2);
        } else if (e.payInterfacePartyType == 10) {
          printlist.totalMoneyDetails.list[3].money = e.money;
          printlist.totalMoneyDetails.list[3].num = e.orderNum;
          printlist.refundMoneyDetails.list[3].money = e.refundMoney;
          printlist.refundMoneyDetails.list[3].num = e.refundNum;
          printlist.retailMoneyDetails.list[3].money = (e.money - e.refundMoney).toFixed(2);
          printlist.retailMoneyDetails.list[3].num = (e.orderNum - e.refundNum).toFixed(2);
        } else if (
          e.payInterfacePartyType == 9 ||
          e.payInterfacePartyType == 8 ||
          e.payInterfacePartyType == 12 ||
          e.payInterfacePartyType == 13
        ) {
          printlist.totalMoneyDetails.list[4].money += e.money;
          printlist.totalMoneyDetails.list[4].num += e.orderNum;
          printlist.refundMoneyDetails.list[4].money += e.refundMoney;
          printlist.refundMoneyDetails.list[4].num += e.refundNum;
          printlist.retailMoneyDetails.list[4].money += (e.money - e.refundMoney).toFixed(2);
          printlist.retailMoneyDetails.list[4].num += (e.orderNum - e.refundNum).toFixed(2);
          if (e.payInterfacePartyType == 8) {
            printlist.totalMoneyDetails.list[5].money = e.money;
            printlist.totalMoneyDetails.list[5].num = e.orderNum;
            printlist.refundMoneyDetails.list[5].money = e.refundMoney;
            printlist.refundMoneyDetails.list[5].num = e.refundNum;
            printlist.retailMoneyDetails.list[5].money =
              (e.money - e.refundMoney).toFixed(2);
            printlist.retailMoneyDetails.list[5].num = (e.orderNum - e.refundNum).toFixed(2)
          }
        }
      });
      console.log(printlist, "printlist");
      var template_html = `
        <form id="from">
        <div class="center column">
          <div class="center shopName boldFont">${this.shopInformation.shopName}</div>
        </div>
         <div class="content1">
          <div>交班人：${this.shitChangeList.cashierUserFullName}</div>
          <div>上班时间：${this.shitChangeList.startTime}</div>
          <div>下班时间：${this.shitChangeList.nowTime}</div>
          <div>上班时长：${this.shitChangeList.workHours}</div>
       
          <div class="br"></div>
        </div>
         <div>
           <div class="  boldFont">营收详情：</div>
          <div class="flex-between">
            <div style="width:40%">收款方式</div>
            <div class="center" style="width:30%">收款金额</div>
            <div style="width:30%;text-align: right;">数量</div>
          </div> `;


      // 收款总数
      printlist.totalMoneyDetails.list.forEach(item => {
        template_html += `<div class="flex-between item">
            <div class="column name" style="width:40%">
              <div class>${item.name}</div>
            </div>
            <div class="justCenter" style="width:30%">￥${item.money}</div>
            <div style="width:30%;text-align: right;">${item.num}笔</div>
              </div>
            </div>`;
      });
      template_html += `  
          <div class="flex-between item">
             <div class="column name" style="width:40%">
              <div class>收款总数</div>
            </div>
            <div style="width:30%;text-align: right;">${printlist.totalMoneyDetails.totalNum}</div>
              </div>
          </div>
          <div class="flex-between item">
             <div class="column name" style="width:60%">
              <div class>收款金额小计</div>
            </div>
            <div style="width:40%;text-align: right;">${printlist.totalMoneyDetails.totalPrice}</div>
            </div>
          </div>
       <div class="br"></div>
          </div>
           <div>
           <div class="  boldFont">退款详情：</div>
          <div class="flex-between">
            <div style="width:40%">收款方式</div>
            <div class="center" style="width:30%">收款金额</div>
            <div style="width:30%;text-align: right;">数量</div>
          </div> `;

      //退款详情
      printlist.refundMoneyDetails.list.forEach(item => {
        template_html += `<div class="flex-between item">
            <div class="column name" style="width:40%">
              <div class>${item.name}</div>
            </div>
            <div class="justCenter" style="width:30%">￥${item.money}</div>
            <div style="width:30%;text-align: right;">${item.num}笔</div>
              </div>
            </div>`;
      });
      template_html += `  
          <div class="flex-between item">
             <div class="column name" style="width:40%">
              <div class>退款总数</div>
            </div>
            <div style="width:30%;text-align: right;">${printlist.refundMoneyDetails.totalNum}</div>
              </div>
          </div>
          <div class="flex-between item">
             <div class="column name" style="width:60%">
              <div class>退款金额小计</div>
            </div>
            <div style="width:40%;text-align: right;">${printlist.refundMoneyDetails.totalPrice}</div>
            </div>
          </div>
       <div class="br"></div>
          </div>
           <div>
           <div class="  boldFont">储值详情：</div>
          <div class="flex-between">
            <div style="width:40%">收款方式</div>
            <div class="center" style="width:30%">收款金额</div>
            <div style="width:30%;text-align: right;">数量</div>
          </div> `;

              //储值详情
      printlist.memberOrderDetails.list.forEach(item => {
        template_html += `<div class="flex-between item">
            <div class="column name" style="width:40%">
              <div class>${item.name}</div>
            </div>
            <div class="justCenter" style="width:30%">￥${item.money}</div>
            <div style="width:30%;text-align: right;">${item.num}笔</div>
              </div>
            </div>`;});
                 template_html += `  
          <div class="flex-between item">
             <div class="column name" style="width:40%">
              <div class>储值总数</div>
            </div>
            <div style="width:30%;text-align: right;">${printlist.memberOrderDetails.totalNum}</div>
              </div>
          </div>
          <div class="flex-between item">
             <div class="column name" style="width:60%">
              <div class>储值金额小计</div>
            </div>
            <div style="width:40%;text-align: right;">${printlist.memberOrderDetails.totalPrice}</div>
            </div>
          </div>
       <div class="br"></div>
          </div>
           <div>
           <div class="  boldFont">现金详情：</div>
          <div class="flex-between">
            <div style="width:40%">收款方式</div>
            <div class="center" style="width:30%">收款金额</div>
            <div style="width:30%;text-align: right;">数量</div>
          </div> `; 
                  //现金详情
      printlist.retailMoneyDetails.list.forEach(item => {
        template_html += `<div class="flex-between item">
            <div class="column name" style="width:40%">
              <div class>${item.name}</div>
            </div>
            <div class="justCenter" style="width:30%">￥${item.money}</div>
            <div style="width:30%;text-align: right;">${item.num}笔</div>
              </div>
            </div>`;
      });
      template_html += ` 
       <div class="flex-between item">
             <div class="column name" style="width:40%">
              <div class>现金总数</div>
            </div>
            <div style="width:30%;text-align: right;">${printlist.retailMoneyDetails.totalNum}</div>
              </div>
          </div>
          <div class="flex-between item">
             <div class="column name" style="width:60%">
              <div class>现金金额小计</div>
            </div>
            <div style="width:40%;text-align: right;">${printlist.retailMoneyDetails.totalPrice}</div>
            </div>
          </div>
       <div class="br"></div>
          </div>
      </form>
        <style>
     .item {
  margin-top: 10px;
}
#from{
  font-size: 12px;
  padding-right:5px
}
.br{  
  border-bottom: 1px dashed  #000;
  margin: 10px 0;
}
.boldFont{
   font-size: 22px;
  font-weight: 600;
}
.shopName{
  margin-bottom:20px;
 
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.row {
  display: flex;
  flex-direction: row;
}

.column {
  display: flex;
  flex-direction: column;
}

.justCenter {
  display: flex;
  justify-content: center;
}

.alignCenter {
  display: flex;
  align-items: center;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}</style>
      `;

      LODOP.PRINT_INIT("交接班小票");
      LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", template_html);
      LODOP.SET_PRINT_PAGESIZE(3, 600, 40, "");
      // LODOP.PREVIEW(); //预览
      LODOP.PRINT(); //打印
    },
    payTypeAmount(startDate, endDate) {
      payTypeAmount({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        startTime: startDate, //筛选开始时间
        endTime: endDate //结束时间
      }).then(res => {
        console.log(res.data);
        if (res.code == 1) {
          this.payTypeAmountList = res.data;
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
        }
      });
    },
    forPayInterfacePartyType(e, arr, typeOf) {
      // typeOf = 1 为退款数据 typeOf =2 实际收款数据
      if (typeOf == 1) {
        if (e.payInterfacePartyType == 11) {
          this.popList[0].money = e.refundMoney;
          this.popList[0].totalMoneyNum = e.refundNum;
        } else if (e.payInterfacePartyType == 3) {
          this.popList[1].money = e.refundMoney;
          this.popList[1].totalMoneyNum = e.refundNum;
        } else if (e.payInterfacePartyType == 2) {
          this.popList[2].money = e.refundMoney;
          this.popList[2].totalMoneyNum = e.refundNum;
        } else if (e.payInterfacePartyType == 8) {
          this.popList[3].money = e.refundMoney;
          this.popList[3].totalMoneyNum = e.refundNum;
        } else if (e.payInterfacePartyType == 10) {
          this.popList[4].money = e.refundMoney;
          this.popList[4].totalMoneyNum = e.refundNum;
        } else if (
          e.payInterfacePartyType == 9 ||
          e.payInterfacePartyType == 8 ||
          e.payInterfacePartyType == 12 ||
          e.payInterfacePartyType == 13
        ) {
          this.popList[5].money += e.refundMoney;
          this.popList[5].totalMoneyNum += e.refundNum;
        }
      } else if (typeOf == 2) {
        if (e.payInterfacePartyType == 11) {
          this.popList[0].money = e.money - e.refundMoney;
          this.popList[0].totalMoneyNum = e.orderNum - e.refundNum;
        } else if (e.payInterfacePartyType == 3) {
          this.popList[1].money = e.money - e.refundMoney;
          this.popList[1].totalMoneyNum = e.orderNum - e.refundNum;
        } else if (e.payInterfacePartyType == 2) {
          this.popList[2].money = e.money - e.refundMoney;
          this.popList[2].totalMoneyNum = e.orderNum - e.refundNum;
        } else if (e.payInterfacePartyType == 8) {
          this.popList[3].money = e.money - e.refundMoney;
          this.popList[3].totalMoneyNum = e.orderNum - e.refundNum;
        } else if (e.payInterfacePartyType == 10) {
          this.popList[4].money = e.money - e.refundMoney;
          this.popList[4].totalMoneyNum = e.orderNum - e.refundNum;
        } else if (
          e.payInterfacePartyType == 9 ||
          e.payInterfacePartyType == 8 ||
          e.payInterfacePartyType == 12 ||
          e.payInterfacePartyType == 13
        ) {
          this.popList[5].money += e.money - e.refundMoney;
          this.popList[5].totalMoneyNum += e.orderNum - e.refundNum;
        }
      } else {
        if (e.payInterfacePartyType == 11) {
          this.popList[0].money = e.money;
          this.popList[0].totalMoneyNum = e.orderNum;
        } else if (e.payInterfacePartyType == 3) {
          this.popList[1].money = e.money;
          this.popList[1].totalMoneyNum = e.orderNum;
        } else if (e.payInterfacePartyType == 2) {
          this.popList[2].money = e.money;
          this.popList[2].totalMoneyNum = e.orderNum;
        } else if (e.payInterfacePartyType == 8) {
          this.popList[3].money = e.money;
          this.popList[3].totalMoneyNum = e.orderNum;
        } else if (e.payInterfacePartyType == 10) {
          this.popList[4].money = e.money;
          this.popList[4].totalMoneyNum = e.orderNum;
        } else if (
          e.payInterfacePartyType == 9 ||
          e.payInterfacePartyType == 8 ||
          e.payInterfacePartyType == 12 ||
          e.payInterfacePartyType == 13
        ) {
          this.popList[5].money += e.money;
          this.popList[5].totalMoneyNum += e.orderNum;
        }
      }
    },
    //金额明细
    priceDetail(a, type) {
      this.popList = [
        {
          name: "现金",
          img: require("../../assets/icon/xj.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "微信",
          img: require("../../assets/icon/wxzf.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "支付宝",
          img: require("../../assets/icon/zfb.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "自有POS刷卡(标记收款)",
          img: require("../../assets/icon/sk.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "会员",
          img: require("../../assets/icon/czk.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "自有支付宝/微信(标记收款)",
          img: require("../../assets/icon/bjskzf.png"),
          money: 0,
          totalMoneyNum: 0
        }
      ];
      this.popShow = true;
      this.left = a;
      var arr = this.payTypeAmountList;
      if (type == "收款金额") {
        arr.totalMoneyDetails.forEach(e => {
          this.forPayInterfacePartyType(e, arr, 3);
        });
      } else if (type == "退款金额") {
        arr.totalMoneyDetails.forEach(e => {
          this.forPayInterfacePartyType(e, arr, 1);
        });
      } else if (type == "实收金额") {
        arr.totalMoneyDetails.forEach(e => {
          this.forPayInterfacePartyType(e, arr, 2);
        });
      } else if (type == "储值金额") {
        arr.memberOrderDetails.forEach(e => {
          this.forPayInterfacePartyType(e, arr, 3);
        });
      }
    },
    //上班
    goToWork() {
      goToWork({
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      }).then(res => {
        console.log(res.data);
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "上班成功"
          });
          this.visible = false;
          this.workingInfo();
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
        }
      });
    },
    //下班
    goOffWork() {
      goOffWork({
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      }).then(res => {
        console.log(res.data);
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "下班成功"
          });
          this.visible = false;
          this.print()
          // this.workingInfo();
          this.$router.push("/");
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
        }
      });
    },
    //交班
    shiftChange() {
      workingStatus({
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      }).then(res => {
        console.log(res.data, 'res.data');
        if (res.code == 1) {
          if (res.data.workingStatus == 1) {
            //状态正在上班
            this.goOffWork();
          } else {
            //状态下班
            this.goToWork();
          }
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
        }
      });
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.MallOrder_findMallOrderProductStatistic(
        this.shitChangeList.startTime,
        this.shitChangeList.nowTime,
        val
      );
    },
    //商品分析数据
    MallOrder_findMallOrderProductStatistic(startDate, endDate, pageNumber) {
      this.request
        .post("qrcapi/MallOrder_findMallOrderProductStatistic", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          startDate: startDate, //筛选开始时间
          endDate: endDate, //结束时间
          pageNumber: pageNumber, // 当前页码
          pageSize: 5 // 每页记录数
        })
        .then(res => {
          console.log(res, "商品分析（分页）");
          if (res.code == 1) {
            this.tableData = res.data.pager.list;
            this.totalCount = res.data.pager.totalCount;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    workingInfo() {
      workingInfo({
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      }).then(res => {
        console.log(res.data, "交接班");
        if (res.code == 1) {
          this.shitChangeList = res.data;
          this.startTime.date = res.data.startTime.substring(0, 10);
          this.startTime.time = res.data.startTime.substring(11);
          this.nowTime.time = res.data.nowTime.substring(11);
          this.nowTime.date = res.data.nowTime.substring(0, 10);
          this.MallOrder_findMallOrderProductStatistic(
            res.data.startTime,
            res.data.nowTime
          );
          this.payTypeAmount(res.data.startTime, res.data.nowTime);
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else if (res.code == 0) {
          this.$message.error(res.msg);
          this.shitChangeList = [];
          this.startTime.date = "";
          this.startTime.time = "";
          this.nowTime.time = "";
          this.nowTime.date = "";
        }
      });
    }
  }
};
</script>

<style>
     .item {
  margin-top: 10px;
}
#from{
  font-size: 12px;
  padding-right:5px
}
.br{  
  border-bottom: 1px dashed  #000;
  margin: 10px 0;
}
.boldFont{
   font-size: 22px;
  font-weight: 600;
}
.shopName{
  margin-bottom:20px;
 
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.row {
  display: flex;
  flex-direction: row;
}

.column {
  display: flex;
  flex-direction: column;
}

.justCenter {
  display: flex;
  justify-content: center;
}

.alignCenter {
  display: flex;
  align-items: center;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}</style>
      `;

      LODOP.PRINT_INIT("交接班小票");
      LODOP.ADD_PRINT_HTM(0, 0, "100%", "100%", template_html);
      LODOP.SET_PRINT_PAGESIZE(3, 600, 40, "");
      // LODOP.PREVIEW(); //预览
      LODOP.PRINT(); //打印
    },
    payTypeAmount(startDate, endDate) {
      payTypeAmount({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        startTime: startDate, //筛选开始时间
        endTime: endDate //结束时间
      }).then(res => {
        console.log(res.data);
        if (res.code == 1) {
          this.payTypeAmountList = res.data;
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
        }
      });
    },
    forPayInterfacePartyType(e, arr, typeOf) {
      // typeOf = 1 为退款数据 typeOf =2 实际收款数据
      if (typeOf == 1) {
        if (e.payInterfacePartyType == 11) {
          this.popList[0].money = e.refundMoney;
          this.popList[0].totalMoneyNum = e.refundNum;
        } else if (e.payInterfacePartyType == 3) {
          this.popList[1].money = e.refundMoney;
          this.popList[1].totalMoneyNum = e.refundNum;
        } else if (e.payInterfacePartyType == 2) {
          this.popList[2].money = e.refundMoney;
          this.popList[2].totalMoneyNum = e.refundNum;
        } else if (e.payInterfacePartyType == 8) {
          this.popList[3].money = e.refundMoney;
          this.popList[3].totalMoneyNum = e.refundNum;
        } else if (e.payInterfacePartyType == 10) {
          this.popList[4].money = e.refundMoney;
          this.popList[4].totalMoneyNum = e.refundNum;
        } else if (
          e.payInterfacePartyType == 9 ||
          e.payInterfacePartyType == 8 ||
          e.payInterfacePartyType == 12 ||
          e.payInterfacePartyType == 13
        ) {
          this.popList[5].money += e.refundMoney;
          this.popList[5].totalMoneyNum += e.refundNum;
        }
      } else if (typeOf == 2) {
        if (e.payInterfacePartyType == 11) {
          this.popList[0].money = e.money - e.refundMoney;
          this.popList[0].totalMoneyNum = e.orderNum - e.refundNum;
        } else if (e.payInterfacePartyType == 3) {
          this.popList[1].money = e.money - e.refundMoney;
          this.popList[1].totalMoneyNum = e.orderNum - e.refundNum;
        } else if (e.payInterfacePartyType == 2) {
          this.popList[2].money = e.money - e.refundMoney;
          this.popList[2].totalMoneyNum = e.orderNum - e.refundNum;
        } else if (e.payInterfacePartyType == 8) {
          this.popList[3].money = e.money - e.refundMoney;
          this.popList[3].totalMoneyNum = e.orderNum - e.refundNum;
        } else if (e.payInterfacePartyType == 10) {
          this.popList[4].money = e.money - e.refundMoney;
          this.popList[4].totalMoneyNum = e.orderNum - e.refundNum;
        } else if (
          e.payInterfacePartyType == 9 ||
          e.payInterfacePartyType == 8 ||
          e.payInterfacePartyType == 12 ||
          e.payInterfacePartyType == 13
        ) {
          this.popList[5].money += e.money - e.refundMoney;
          this.popList[5].totalMoneyNum += e.orderNum - e.refundNum;
        }
      } else {
        if (e.payInterfacePartyType == 11) {
          this.popList[0].money = e.money;
          this.popList[0].totalMoneyNum = e.orderNum;
        } else if (e.payInterfacePartyType == 3) {
          this.popList[1].money = e.money;
          this.popList[1].totalMoneyNum = e.orderNum;
        } else if (e.payInterfacePartyType == 2) {
          this.popList[2].money = e.money;
          this.popList[2].totalMoneyNum = e.orderNum;
        } else if (e.payInterfacePartyType == 8) {
          this.popList[3].money = e.money;
          this.popList[3].totalMoneyNum = e.orderNum;
        } else if (e.payInterfacePartyType == 10) {
          this.popList[4].money = e.money;
          this.popList[4].totalMoneyNum = e.orderNum;
        } else if (
          e.payInterfacePartyType == 9 ||
          e.payInterfacePartyType == 8 ||
          e.payInterfacePartyType == 12 ||
          e.payInterfacePartyType == 13
        ) {
          this.popList[5].money += e.money;
          this.popList[5].totalMoneyNum += e.orderNum;
        }
      }
    },
    //金额明细
    priceDetail(a, type) {
      this.popList = [
        {
          name: "现金",
          img: require("../../assets/icon/xj.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "微信",
          img: require("../../assets/icon/wxzf.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "支付宝",
          img: require("../../assets/icon/zfb.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "自有POS刷卡(标记收款)",
          img: require("../../assets/icon/sk.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "会员",
          img: require("../../assets/icon/czk.png"),
          money: 0,
          totalMoneyNum: 0
        },
        {
          name: "自有支付宝/微信(标记收款)",
          img: require("../../assets/icon/bjskzf.png"),
          money: 0,
          totalMoneyNum: 0
        }
      ];
      this.popShow = true;
      this.left = a;
      var arr = this.payTypeAmountList;
      if (type == "收款金额") {
        arr.totalMoneyDetails.forEach(e => {
          this.forPayInterfacePartyType(e, arr, 3);
        });
      } else if (type == "退款金额") {
        arr.totalMoneyDetails.forEach(e => {
          this.forPayInterfacePartyType(e, arr, 1);
        });
      } else if (type == "实收金额") {
        arr.totalMoneyDetails.forEach(e => {
          this.forPayInterfacePartyType(e, arr, 2);
        });
      } else if (type == "储值金额") {
        arr.memberOrderDetails.forEach(e => {
          this.forPayInterfacePartyType(e, arr, 3);
        });
      }
    },
    //上班
    goToWork() {
      goToWork({
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      }).then(res => {
        console.log(res.data);
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "上班成功"
          });
          this.visible = false;
          this.workingInfo();
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
        }
      });
    },
    //下班
    goOffWork() {
      goOffWork({
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      }).then(res => {
        console.log(res.data);
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "下班成功"
          });
          this.visible = false;
          this.print()
          // this.workingInfo();
          this.$router.push("/");
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
        }
      });
    },
    //交班
    shiftChange() {
      workingStatus({
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      }).then(res => {
        console.log(res.data, 'res.data');
        if (res.code == 1) {
          if (res.data.workingStatus == 1) {
            //状态正在上班
            this.goOffWork();
          } else {
            //状态下班
            this.goToWork();
          }
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
        }
      });
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.MallOrder_findMallOrderProductStatistic(
        this.shitChangeList.startTime,
        this.shitChangeList.nowTime,
        val
      );
    },
    //商品分析数据
    MallOrder_findMallOrderProductStatistic(startDate, endDate, pageNumber) {
      this.request
        .post("qrcapi/MallOrder_findMallOrderProductStatistic", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          startDate: startDate, //筛选开始时间
          endDate: endDate, //结束时间
          pageNumber: pageNumber, // 当前页码
          pageSize: 5 // 每页记录数
        })
        .then(res => {
          console.log(res, "商品分析（分页）");
          if (res.code == 1) {
            this.tableData = res.data.pager.list;
            this.totalCount = res.data.pager.totalCount;
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    workingInfo() {
      workingInfo({
        sessionId: this.userList.sessionId,
        userId: this.userList.id
      }).then(res => {
        console.log(res.data, "交接班");
        if (res.code == 1) {
          this.shitChangeList = res.data;
          this.startTime.date = res.data.startTime.substring(0, 10);
          this.startTime.time = res.data.startTime.substring(11);
          this.nowTime.time = res.data.nowTime.substring(11);
          this.nowTime.date = res.data.nowTime.substring(0, 10);
          this.MallOrder_findMallOrderProductStatistic(
            res.data.startTime,
            res.data.nowTime
          );
          this.payTypeAmount(res.data.startTime, res.data.nowTime);
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else if (res.code == 0) {
          this.$message.error(res.msg);
          this.shitChangeList = [];
          this.startTime.date = "";
          this.startTime.time = "";
          this.nowTime.time = "";
          this.nowTime.date = "";
        }
      });
    }
  }
};
</script>
<style  scoped>
.pop-icon {
  width: 30px;
  height: 30px;
  margin-right: 20px;
}
.pop::after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-bottom: 5px solid #fff;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  top: -5px;
  left: 45%;
}
.pop {
  padding: 30px;
  box-shadow: 1px 1px 2px #ddd;
  background: #fff;
  position: absolute;
  /* left: 100px; */
  top: 70px;
  z-index: 999;
  color: rgba(85, 85, 85, 1);
  font-size: 14px;
  display: grid;
  grid-template-columns: repeat(3, 152px);
  grid-template-rows: repeat(2, 100px);
  grid-gap: 30px;
}
.ifm-item {
  display: flex;
  flex-grow: 1;
  /* align-items: center; */
  flex-direction: column;
}

.montyKey {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
  line-height: 48px;
}
.money {
  font-size: 24px;
  font-weight: bold;
}
.moneyNumber {
  font-size: 14px;
  color: #999999;
  margin-left: 5px;
  font-weight: 400;
}
.information {
  position: relative;
  margin: 30px;
  margin-top: 0;
  padding: 29px 44px;
  box-sizing: border-box;
  /* width: 100%; */
  background: rgba(248, 248, 249, 1);
}
.popButton {
  margin-top: 19px;
}
.popWrap {
  font-size: 12px;
}
.popText {
  margin-top: 13px;
}
.content-top__date {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 48px;
}
.content-top_value {
  font-size: 18px;
  font-family: PingFang;
  font-weight: 800;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
}
.content-top_key {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 24px;
}
.popIcon {
  height: 23px;
  width: 23px;
  /* margin-right: 23px; */
}
.popIcon img {
  height: 100%;
  width: 100%;
}
.content-top-img {
  height: 58px;
  width: 58px;
  margin-right: 23px;
}
.content-top-img img {
  height: 100%;
  width: 100%;
}
.content-top {
  display: flex;
  flex-grow: 1;
  background: rgba(248, 248, 249, 1);
  border-radius: 4px;
  height: 127px;
  padding: 35px 28px;
  box-sizing: border-box;
}
.content-top:not(:first-child) {
  margin-left: 30px;
}
.content {
  padding: 30px;
  box-sizing: border-box;
  width: 100%;
}
.title {
  font-size: 14px;
  color: #666666;
  box-sizing: border-box;
  width: 100%;
  padding: 30px 0px 20px 30px;
  background: #f8f8f8;
  padding-top: 70px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/shiftChange.vue